// Shared period vocabulary for the report cards. The month/year lives on the
// Reports page so the monthly close is picked once and every city's card uses
// it; anything finer (week, day, custom range) belongs to the one card that
// supports it.

export const MONTH_NAMES = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
];

export const MONTH_OPTIONS = Array.from({ length: 12 }, (_, i) => i + 1);

/** Current year ± 5. */
export const yearOptions = (): number[] => {
    const current = new Date().getFullYear();
    return Array.from({ length: 11 }, (_, i) => current - 5 + i);
};
